module.exports = __webpack_public_path__ + "img/icon-close-blue.2e8c0d1a.svg";